const PropTypes = require('prop-types');
//@vendors
const React = require('react');

//@commons
const StorySummary = require('../news/brokerStorySummary');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
//@helpers
const { DATE_FORMAT_ES, DATE_FORMAT_SHORT_TIME_24 } = require('constants/index');
const DateHelper = require('utilities/dateHelper');
const { formatText } = require('core/i18n').i18n;



class PulsesColumn extends React.Component {
    componentDidMount() {
        this.props.requestMarketPulses({
            start: 0,
            end: 20
        });
    }

    buildArticles() {
        const {
            immMarketsPulses,
            maxPulses,
            pageName
        } = this.props;
        const pulseData = immMarketsPulses.get('byOrder');
        const pulses = pulseData.splice(0, maxPulses).map((pulseId, index) => {
            const immPulse = immMarketsPulses.getIn(['byId', pulseId]);
            const parsedDate = `${DateHelper.buildFormattedDate(immPulse.get('date'), DATE_FORMAT_ES)} - ${DateHelper.buildFormattedDate(immPulse.get('date'), DATE_FORMAT_SHORT_TIME_24)}`;
            const link = `/myprofile/broker/pulses/${immPulse.get('id')}`;
            const text = immPulse.get('inlet').length ? immPulse.get('inlet') : immPulse.get('body');
            return (
                <article key={index} className="col-lg-12">
                    <StorySummary
                        myDate={parsedDate}
                        title={immPulse.get('title')}
                        summary={text}
                        readMore={true}
                        myPath={link}
                        pageName={pageName}
                    />
                </article>
            );
        });

        return pulses;
    }

    render() {
        const {
            immMarketsPulses
        } = this.props;

        if (immMarketsPulses.get('isFetching')) {
            return (<LoadingSection />);
        }

        if (immMarketsPulses.get('error')) {
            return (<p>Ha ocurrido un error</p>);
        }

        const pulses = this.buildArticles();

        if (pulses.size === 0) {
            const primaryText = formatText('broker-emptyPulses');
            return (
                <EmptyState
                    primaryText={primaryText}
                    iconType="noitems-wealth" />
            );
        } else {
            return (
                <div className="row">
                    {pulses}
                </div>
            );
        }
    }
}

PulsesColumn.propTypes = {
    immMarketsPulses: PropTypes.object.isRequired,
    requestMarketPulses: PropTypes.func.isRequired,
    maxPulses: PropTypes.number.isRequired,
    pageName: PropTypes.string
}

module.exports = PulsesColumn;
